"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var FilterItem = function FilterItem(_ref) {
  var isCurrent = _ref.isCurrent,
      key = _ref.key,
      topLevel = _ref.topLevel,
      contentLevel = _ref.contentLevel,
      children = _ref.children,
      hasChildren = _ref.hasChildren,
      toggleCategory = _ref.toggleCategory,
      categoryId = _ref.categoryId,
      isExpanded = _ref.isExpanded,
      onSelect = _ref.onSelect;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('categories-navigation-link', {
      'categories-navigation-link--current': isCurrent,
      'categories-navigation-link--top-level': topLevel,
      'categories-navigation-link--content-level': contentLevel
    }),
    key: key,
    onClick: onSelect,
    role: "button",
    tabIndex: 0,
    onKeyUp: function onKeyUp(e) {
      if (e.code === 'Enter') {
        onSelect();
      }
    }
  }, hasChildren && (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.collapse",
    renderAsText: true
  }, function (accessibilityLabelCollapse) {
    return (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.expand",
      renderAsText: true
    }, function (accessibilityLabelExpand) {
      return (0, _preact.h)("div", {
        role: "button",
        "aria-label": isExpanded ? accessibilityLabelCollapse : accessibilityLabelExpand,
        tabIndex: 0,
        onKeyUp: function onKeyUp(e) {
          e.stopPropagation();
          e.preventDefault();

          if (e.code === 'Enter') {
            toggleCategory(categoryId);
          }
        },
        className: "category-sidebar-navigation__toggle",
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();
          toggleCategory(categoryId);
        }
      }, isExpanded ? (0, _preact.h)(_ChevronUp.default, null) : (0, _preact.h)(_ChevronDown.default, null));
    });
  }), children);
};

var _default = FilterItem;
exports.default = _default;